import Impersonation from './Impersonation';

export default Impersonation;
